import {useEffect, useRef} from "react";
import {Animated, SafeAreaView, StyleSheet, View} from "react-native";
import Text from "./Text";
import FontAwesome from "./FontAwesome";
import {RowSpace} from "./_CommonComponents";
import {SnackBarData} from "../../../contexts/AppConfigContext";

function SnackBar(props: any) {

    if(props.data == null)
        return <></>;

    const data :SnackBarData = props.data as SnackBarData;

    const moveAnim = useRef(new Animated.Value(100)).current;
    const fadeAnim = useRef(new Animated.Value(0)).current;

    const moveIn = () => {
        Animated.timing(moveAnim, {
            toValue: 0,
            duration: 350,
            useNativeDriver: false
        }).start();
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 350,
            useNativeDriver: false
        }).start();
    };

    const moveOut = () => {
        Animated.timing(moveAnim, {
            toValue: 100,
            duration: 350,
            useNativeDriver: false
        }).start();
        Animated.timing(fadeAnim, {
            toValue: 0,
            duration: 350,
            useNativeDriver: false
        }).start();
    };

    useEffect(() => {
        const timeout = setTimeout(()=>{
            moveOut()
        }, 3000);
        return () => {
            clearTimeout(timeout);
        }
    });
    useEffect(() => {
        moveIn();
    }, [props.data]);

    const colors = {
        red: {
            back: "#FF1744",
            sep: "#CE0000",
            text: "#fff"
        },
        green: {
            back: "#00ED62",
            sep: "#128100",
            text: "#fff"
        },
        yellow: {
            back: "#FFBF3C",
            sep: "#DC8400",
            text: "#000"
        }
    }

    const schemeName = data?.color ?? 'green';
    const scheme = colors[schemeName];

    const lStyles = StyleSheet.create({
        notificationBar: {
            width: "100%",
            position: "absolute",
            alignSelf: "center",
            bottom: 0,
            flexDirection: "column",
        },
        rest:{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: scheme.back,
            paddingHorizontal: 20,
            paddingVertical: 10
        },
        separatorBar: {
            backgroundColor: scheme.sep,
            height: 2,
            width: "100%"
        }
    });

    return <SafeAreaView>
        <Animated.View style={{transform: [{translateY: moveAnim}], opacity: fadeAnim}}>
            <View style={lStyles.notificationBar}>
                <View style={lStyles.separatorBar}/>
                <View style={lStyles.rest}>
                    <Text style={{fontSize: 14, fontWeight: 500 }} color={scheme.text}>{props.data.text}</Text>
                    <RowSpace/>
                    <FontAwesome color={scheme.text} size={22} icon={props.data.icon}/>
                </View>
            </View>
        </Animated.View>
    </SafeAreaView>
}

export {SnackBar}